export const CURRENT_FISCAL_YEAR = 'CURRENT_FISCAL_YEAR';
export const MY_TEAM_ACCORDION_STATE = 'MY_TEAM_ACCORDION_STATE';
